/**
 * Half-hour steps for open/close selects (values are 24h "HH:mm" for stable keys).
 */
const format12hLabel = (hour24, minute) => {
  const period = hour24 < 12 ? 'AM' : 'PM';
  const hour12 = hour24 % 12 || 12;
  const minuteStr = String(minute).padStart(2, '0');

  return `${hour12}:${minuteStr} ${period}`;
};

const getValue = (hour24, minute) =>
  `${String(hour24).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;

export const buildHalfHourTimeOptions = () =>
  [...new Array(24)].reduce((options, _, hour24) => {
    [0, 30].forEach((minute) => {
      options.push({
        label: format12hLabel(hour24, minute),
        value: getValue(hour24, minute),
      });
    });
    return options;
  }, []);

export const TIME_OPTIONS = buildHalfHourTimeOptions();
